/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class SecurityValueGrid extends SiteEntityGrid<SecurityValueRow, any> {
        protected getColumnsKey() { return 'Data.SecurityValue'; }
        protected getDialogType() { return SecurityValueDialog; }
        protected getIdProperty() { return SecurityValueRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityValueRow.localTextPrefix; }
        protected getService() { return SecurityValueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}